export default __webpack_public_path__ + "static/media/welcome-api-connect.436de28d.png";